
// For tweening values

type TweenAnimationCurve = 'Linear'

export interface TweenerParams<Type> {
  StartValue : Type,
  EndValue : Type,
  OnStart? : ((value:Type) => void),
  OnUpdate? : ((value:Type) => void),
  OnEnd? : ((value:Type) => void)
  duration : number,
  animationCurve? : TweenAnimationCurve // TODO : for now its a Enum, but down the line, we may have to create a custom AnimationCurve type, like unity https://docs.unity3d.com/ScriptReference/AnimationCurve.html
}

export abstract class BaseTweener<Type> {
  public startValue : Type
  public endValue : Type

  public progress : number = 0
  public duration : number

  public OnStart : ((value:Type) => void) | null
  public OnUpdate : ((value:Type) => void) | null
  public OnEnd : ((value:Type) => void) | null

  public playing : boolean = false

  public animationCurve : TweenAnimationCurve

  constructor (_params : TweenerParams<Type>) {
    this.startValue = _params.StartValue
    this.endValue = _params.EndValue
    this.OnStart = _params.OnStart ?? null
    this.OnUpdate = _params.OnUpdate ?? null
    this.OnEnd = _params.OnEnd ?? null
    this.duration = _params.duration
    this.animationCurve = _params.animationCurve ?? 'Linear'
  }

  protected abstract ProcessValue(_startValue:Type, _endValue:Type, _position:number) : Type

  public GetValue () : Type {
    return this.ProcessValue(this.startValue, this.endValue, this.progress / this.duration)
  }

  public Start () : void {
    this.Reset()
    this.playing = true
    if (this.OnStart !== null) this.OnStart(this.ProcessValue(this.startValue, this.endValue, 0))
  }

  public Update (_deltaTime:number) : void {
    if ((this.progress / this.duration) > 1) {
      this.playing = false
      this.progress = this.duration
      if (this.OnEnd != null) this.OnEnd(this.ProcessValue(this.startValue, this.endValue, 1))
    }
    if (this.playing === false) return
    this.progress += _deltaTime
    if (this.OnUpdate != null) this.OnUpdate(this.ProcessValue(this.startValue, this.endValue, this.progress / this.duration))
  }

  public Reset () : void {
    this.progress = 0
  }

  public Pause () : void {
    this.playing = false
  }
}

// As we move forward we can create tweeners for further types

export class TweenNumber extends BaseTweener<number> {
  protected ProcessValue (_startValue: number, _endValue: number, _position: number): number {
    return _startValue + ((_endValue - _startValue) * _position)
  }
}
